import { Box, Typography, Divider, Button, Modal, ModalDialog, ModalClose } from "@mui/joy";
import { Trash2, AlertTriangle } from "lucide-react";
import { useState } from "react";

interface ActionProps {
    onDelete: () => void;
    isDeleting?: boolean;
    manufacturerName?: string;
}

export function Action({ onDelete, isDeleting = false, manufacturerName }: ActionProps) {
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);

    function handleDeleteClick() {
        setShowDeleteDialog(true);
    }

    function handleDeleteConfirm() {
        setShowDeleteDialog(false);
        onDelete();
    }

    function handleDeleteCancel() {
        setShowDeleteDialog(false);
    }

    return (
        <Box>
            <Box mt={2}>
                <Divider sx={{ mb: 1 }} />
                <Typography level="body-sm" sx={{ mb: 1 }} color="danger">
                    Below actions will update or delete this manufacturer in the system.
                </Typography>
                <Box display="flex" gap={2} justifyContent="flex-end">
                    <Button
                        variant="soft"
                        color="danger"
                        onClick={handleDeleteClick}
                        disabled={isDeleting}
                        startDecorator={<Trash2 size={16} />}
                    >
                        {isDeleting ? "Deleting..." : "Delete Manufacturer"}
                    </Button>
                </Box>
            </Box>

            <Modal open={showDeleteDialog} onClose={handleDeleteCancel}>
                <ModalDialog variant="outlined" role="alertdialog" sx={{ maxWidth: 400 }}>
                    <ModalClose />
                    <Box display="flex" alignItems="center" gap={1} mb={2}>
                        <AlertTriangle size={20} />
                        <Typography level="title-md">Delete Manufacturer</Typography>
                    </Box>
                    <Typography level="body-md" sx={{ mb: 3 }}>
                        Are you sure you want to delete the manufacturer "{manufacturerName}"? This action cannot be
                        undone. All associated products will also be removed.
                    </Typography>
                    <Box display="flex" gap={2} justifyContent="flex-end">
                        <Button variant="soft" color="neutral" onClick={handleDeleteCancel} disabled={isDeleting}>
                            Cancel
                        </Button>
                        <Button
                            variant="soft"
                            color="danger"
                            onClick={handleDeleteConfirm}
                            disabled={isDeleting}
                            loading={isDeleting}
                        >
                            Delete
                        </Button>
                    </Box>
                </ModalDialog>
            </Modal>
        </Box>
    );
}
